/* M de María: separa "Terminación" en Formato / Marco / Paspartú (usa las mismas variantes) */
(function(){
  var DIG='Ilustración digital (archivo para imprimir)';
  function parse(v){
    if(v===DIG) return {f:'d'};
    if(v==='Lámina sola') return {f:'l'};
    var m=v.match(/Marco (mañío|blanco) (con|sin) paspartú/i);
    return m?{f:'c',m:m[1].toLowerCase(),p:m[2].toLowerCase()}:null;
  }
  function pill(name,val,label,checked,disabled){
    var id='mdm-'+name+'-'+val;
    return '<input type="radio" id="'+id+'" name="mdm-'+name+'" value="'+val+'"'+(checked?' checked':'')+(disabled?' class="disabled"':'')+'>'+
           '<label for="'+id+'">'+label+'</label>';
  }
  function setup(){
    var vs=document.querySelector('variant-selects'); if(!vs) return;
    var fs=[].slice.call(vs.querySelectorAll('fieldset')).filter(function(f){var l=f.querySelector('legend');return l&&/Terminaci/i.test(l.textContent);})[0];
    if(!fs) return;
    fs.style.display='none';
    var radios=[].slice.call(fs.querySelectorAll('input[type=radio]'));
    var byVal={}; radios.forEach(function(r){byVal[r.value]=r;});
    var cur=radios.filter(function(r){return r.checked;})[0]; var st=cur?parse(cur.value):null; if(!st) return;
    var ui=document.getElementById('mdm-term');
    if(!ui){ui=document.createElement('div');ui.id='mdm-term';fs.parentNode.insertBefore(ui,fs);}
    else if(ui.parentNode!==fs.parentNode){fs.parentNode.insertBefore(ui,fs);}
    var hasC=radios.some(function(r){var p=parse(r.value);return p&&p.f==='c';});
    var hasL=!!byVal['Lámina sola'], hasD=!!byVal[DIG];
    function dis(v){var r=byVal[v];return !r||r.classList.contains('disabled')||r.disabled;}
    var h='<fieldset class="product-form__input product-form__input--pill"><legend class="form__label">Formato</legend>';
    if(hasC) h+=pill('f','c','Cuadro enmarcado',st.f==='c',false);
    if(hasL) h+=pill('f','l','Lámina sola',st.f==='l',dis('Lámina sola'));
    if(hasD) h+=pill('f','d','Ilustración digital (archivo para imprimir)',st.f==='d',dis(DIG));
    h+='</fieldset>';
    if(st.f==='c'){
      var mv=['mañío','blanco'].filter(function(m){return byVal['Marco '+m+' con paspartú']||byVal['Marco '+m+' sin paspartú'];});
      h+='<fieldset class="product-form__input product-form__input--pill"><legend class="form__label">Marco</legend>';
      mv.forEach(function(m){h+=pill('m',m,m==='mañío'?'Mañío natural':'Blanco',st.m===m,dis('Marco '+m+' '+st.p+' paspartú')&&dis('Marco '+m+' '+(st.p==='con'?'sin':'con')+' paspartú'));});
      h+='</fieldset><fieldset class="product-form__input product-form__input--pill"><legend class="form__label">Paspartú</legend>';
      ['con','sin'].forEach(function(p){if(byVal['Marco '+st.m+' '+p+' paspartú']) h+=pill('p',p,p==='con'?'Con paspartú':'Sin paspartú',st.p===p,dis('Marco '+st.m+' '+p+' paspartú'));});
      h+='</fieldset>';
    } else if(st.f==='d'){
      h+='<p class="mdm-note" style="margin:-.4rem 0 1rem">Recibes por correo el archivo en alta resolución para imprimir en casa o en una imprenta. Sin envío físico.</p>';
    }
    ui.innerHTML=h;
    ui.onchange=function(e){
      var t=e.target; if(!t||t.type!=='radio') return; e.stopPropagation();
      var s={f:st.f,m:st.m||'mañío',p:st.p||'con'};
      if(t.name==='mdm-f') s.f=t.value; if(t.name==='mdm-m') s.m=t.value; if(t.name==='mdm-p') s.p=t.value;
      var target;
      if(s.f==='l') target='Lámina sola'; else if(s.f==='d') target=DIG;
      else { target='Marco '+s.m+' '+s.p+' paspartú';
        if(!byVal[target]) target=['Marco '+s.m+' con paspartú','Marco '+s.m+' sin paspartú','Marco mañío con paspartú','Marco blanco con paspartú'].filter(function(v){return byVal[v];})[0]; }
      var r=byVal[target]; if(!r) return;
      r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true}));
      setTimeout(setup,50);
    };
  }

  /* La ilustración digital se vende como producto aparte (digital-<diseño>) para que no le aplique el descuento de colección */
  var DMAP=null;
  (function(){var m=location.pathname.match(/\/products\/cuadro-([^\/?#]+)/); if(!m) return;
    fetch('/products/digital-'+m[1]+'.js').then(function(r){return r.ok?r.json():null;}).then(function(p){ if(!p) return; DMAP={};
      p.variants.forEach(function(v){ var k=(v.option1||'').match(/\d+/g); if(k){k=k.map(Number).sort(function(a,b){return a-b}).join('x'); DMAP[k]=v.id;} }); }).catch(function(){});})();
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f||!/\/cart\/add/.test(f.getAttribute('action')||'')||!DMAP) return;
    var vs=document.querySelector('variant-selects'); if(!vs) return;
    var t=vs.querySelector('input[name^="Terminación"]:checked'); if(!t||t.value!==DIG) return;
    var s=vs.querySelector('input[name^="Tamaño"]:checked'); if(!s) return;
    var k=(s.value.match(/\d+/g)||[]).map(Number).sort(function(a,b){return a-b}).join('x');
    var id=f.querySelector('input[name="id"]'); if(id&&DMAP[k]) id.value=DMAP[k];
  },true);

  /* "Comprar ahora" con Ilustración digital: va directo al pago con el producto digital */
  document.addEventListener('click',function(e){
    var b=e.target&&e.target.closest&&e.target.closest('.shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout');
    if(!b||!DMAP) return;
    var vs=document.querySelector('variant-selects'); if(!vs) return;
    var t=vs.querySelector('input[name^="Terminación"]:checked'); if(!t||t.value!==DIG) return;
    var s=vs.querySelector('input[name^="Tamaño"]:checked'); if(!s) return;
    var k=(s.value.match(/\d+/g)||[]).map(Number).sort(function(a,b){return a-b}).join('x'); if(!DMAP[k]) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var q=document.querySelector('input[name="quantity"]'); q=q&&parseInt(q.value,10)>0?parseInt(q.value,10):1;
    location.href='/cart/'+DMAP[k]+':'+q;
  },true);
  var tmr; function later(){clearTimeout(tmr);tmr=setTimeout(setup,30);}
  document.addEventListener('DOMContentLoaded',setup); if(document.readyState!=='loading') setup();
  new MutationObserver(function(ms){ if(ms.some(function(m){return !(m.target.closest&&m.target.closest('#mdm-term'));})) later(); })
    .observe(document.documentElement,{childList:true,subtree:true});
})();
